import {
  CONNECTORS_IDS,
  CONNECTORS_IDS_GROUPED,
  type TConnectorId,
} from "~/ui-rtk/constants/sources"

export const CONNECTION_FLOW_STEPS = [
  {
    order: 0,
    title: "First, let's bring in your DTC ecomm analytics data",
    requiredConnectors: [CONNECTORS_IDS.GOOGLE_ANALYTICS_4],
  },
  {
    order: 1,
    title: "Next, let's bring in all your Facebook data",
    requiredConnectors: [
      CONNECTORS_IDS.FACEBOOK_ADS,
      CONNECTORS_IDS.FACEBOOK_PAGES,
    ],
  },
  {
    order: 2,
    title:
      "Instagram is up next. We need to make two connections to get a complete data set!",
    requiredConnectors: [
      CONNECTORS_IDS.INSTAGRAM_INSIGHTS,
      CONNECTORS_IDS.INSTAGRAM_BUSINESS,
    ],
  },
  {
    order: 3,
    title: "Next let's onboard your Tiktok Ads data",
    requiredConnectors: [CONNECTORS_IDS.TIKTOK_ADS],
  },
  {
    order: 4,
    title:
      "And, finally, let's bring on your Tiktok Organic data - note: the login here will be for your company's business Tiktok profile - not a personal account",
    requiredConnectors: [CONNECTORS_IDS.TIKTOK],
  },
]

// Flatten all connector IDs from the groups (including both base and AIRBYTE versions)
export const ESSENTIAL_CONNECTION_FLOW_CONNECTORS_IDS: TConnectorId[] = [
  ...new Set(
    CONNECTION_FLOW_STEPS.reduce((acc, step) => {
      const allConnectorIds = step.requiredConnectors.flatMap(connectorId => {
        // Find the group key that matches this connector ID
        const groupKey = Object.keys(CONNECTORS_IDS_GROUPED).find(key =>
          CONNECTORS_IDS_GROUPED[
            key as keyof typeof CONNECTORS_IDS_GROUPED
          ].includes(connectorId),
        )

        // If found in a group, return all IDs from that group, otherwise just the connector ID
        if (groupKey) {
          return CONNECTORS_IDS_GROUPED[
            groupKey as keyof typeof CONNECTORS_IDS_GROUPED
          ]
        }

        return [connectorId]
      })

      return [...acc, ...allConnectorIds]
    }, [] as TConnectorId[]),
  ),
]
